import { RouteRecordRaw } from 'vue-router'

import {
  BrelagMandatorAppUrls,
  brelagMandatorRouteName,
  VIEW_ID,
} from '@/apps/brelag/mandator-admin/app'
import { clientAppRegistryGet } from '@/apps/clientAppRegistry'
import RouterPassThrough from '@/components/common/RouterPassThrough.vue'

import MainMenu from './components/MainMenu.vue'

const route: RouteRecordRaw = {
  path: clientAppRegistryGet(VIEW_ID, 'path'),
  name: VIEW_ID,
  redirect: { name: brelagMandatorRouteName('profile-list') },
  components: {
    default: RouterPassThrough,
    'main-menu': MainMenu,
  },
  children: [
    {
      path: 'profile',
      name: brelagMandatorRouteName('profile-root'),
      redirect: { name: brelagMandatorRouteName('profile-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: brelagMandatorRouteName('profile-list'),
          props: true,
          component: () => import('./components/user/MandatorUserList.vue'),
        },
        {
          path: 'create',
          name: brelagMandatorRouteName('profile-create'),
          component: () => import('./components/user/MandatorUserForm.vue'),
          props: { id: '0' },
        },
        {
          path: ':id',
          name: brelagMandatorRouteName('profile-detail'),
          props: true,
          component: () => import('./components/user/MandatorUserForm.vue'),
        },
      ],
    },
    {
      path: 'webshop',
      name: brelagMandatorRouteName('webshop-root'),
      redirect: { name: brelagMandatorRouteName('coin-shop') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'coin-shop',
          name: brelagMandatorRouteName('coin-shop'),
          props: true,
          component: () => import('./components/coin/CoinShop.vue'),
        },
      ],
    },
    {
      path: 'order',
      name: brelagMandatorRouteName('order-root'),
      redirect: {
        name: brelagMandatorRouteName(BrelagMandatorAppUrls.ORDER_LIST),
      },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: BrelagMandatorAppUrls.ORDER_LIST,
          name: brelagMandatorRouteName(BrelagMandatorAppUrls.ORDER_LIST),
          props: true,
          component: () => import('./components/order/CoinOrderList.vue'),
        },
        {
          path: ':id/order',
          name: brelagMandatorRouteName(BrelagMandatorAppUrls.ORDER_DETAIL),
          props: true,
          component: () => import('./components/order/CoinOrderDetail.vue'),
        },
      ],
    },
  ],
}

export default route
